<template>
  <div v-if="!isLoading" class="digital-twin-container">
    <error-popup v-show="showErrorModal" @close="showErrorModal = false">
      <h3 slot="header">Error</h3>
      <div slot="body">{{ errorModalText }}</div>
    </error-popup>
    <div v-show="showNoVNC" class="iframe-container">
      <vue-no-vnc
        v-if="
          isSessionActive &&
            machineState !== 'STOPPING' &&
            machineState !== 'STARTING'
        "
        :key="vmInfo.publicDNS"
        :host="vmInfo.publicDNS"
        :username="vmInfo.connectionDetails.winAdminUser"
        :userpassword="vmInfo.connectionDetails.winAdminPassword"
        port="8080"
        path="tightvnc"
        password="Password1!"
      />
    </div>
  </div>
  <div v-else class="loading-container">
    <a-icon slot="indicator" type="loading" style="font-size: 48px" spin />
  </div>
</template>

<script>
import axios from "@/api/index";
import VueNoVNC from "@/components/VueNoVNC";
import ErrorPopup from "@/components/ErrorPopup";
import { getOneSession, getSessions } from "@/api/vm";
import { ONE_MINUTE } from "@/config/time";
import { tokenRequest } from "@/config/authConfig";
import { isMachineInActiveState, getMachineState } from "@/utils/vm";
import { isBefore } from "date-fns";

export default {
  name: "DigitalTwin",
  data() {
    return {
      isLoading: true,
      showNoVNC: true,
      showModal: true,
      timerIncrementTimeout: null,
      keepAliveTimeout: null,
      showErrorModal: false,
      errorModalText: "",
      isInitialized: false,
      token: "",
      idleTime: 0,
      totalCreditsForThisMonth: 0,
      usedCreditsThisMonth: 0,
      vmInfo: {
        machineState: "",
        machineStateValue: "",
        expectedShutdownTime: "",
        startTime: "",
        publicDNS: "",
        publicIP: "",
        computerName: "",
        resourceGroup: "",
        eosMachineState: "",
        eosProvisioningState: "",
        vpnMachineState: "",
        vpnProvisioningState: "",
        isStopping: true,
        connectionDetails: {
          winAdminUser: "",
          winAdminPassword: "",
          vpnUser: "",
          vpnPassword: "",
          vpnPresharedKey: ""
        }
      }
    };
  },
  components: {
    "vue-no-vnc": VueNoVNC,
    "error-popup": ErrorPopup
  },
  computed: {
    isSessionActive: function() {
      if (this.vmInfo) {
        return isMachineInActiveState(this.vmInfo.machineStateValue);
      }
      return false;
    },
    machineState: function() {
      return getMachineState(this.vmInfo.machineStateValue);
    }
  },
  methods: {
    getToken() {
      this.$msal
        .acquireToken(tokenRequest)
        .then(userData => {
          this.token = userData.accessToken;
          axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${userData.accessToken}`;
          this.getVM();
        })
        .catch(error => {
          console.log(error);
          this.$router.replace({ path: "/" });
        });
    },
    getVM() {
      if (this.processing) {
        return;
      }
      const { sessionId } = this.$route.params;

      if (!sessionId) return;

      getOneSession(sessionId)
        .then(response => {
          if (response.data === "") {
            this.vmInfo.machineState = "";
            this.vmInfo.machineStateValue = "";
            this.vmInfo.expectedShutdownTime = "";
            this.vmInfo.publicDNS = "";
            this.vmInfo.isStopping = false;
          } else {
            this.vmInfo = {
              machineState: response.data.machineState,
              machineStateValue: response.data.machineStateValue,
              expectedShutdownTime: response.data.expectedShutdownTime,
              startTime: response.data.startTime,
              publicIP: response.data.publicIP,
              publicDNS: response.data.publicDNS,
              computerName: response.data.computerName,
              resourceGroup: response.data.resourceGroup,
              isStopping: response.data.isStopping,
              connectionDetails: {
                winAdminUser: "",
                winAdminPassword: "",
                vpnUser: "",
                vpnPassword: "",
                vpnPresharedKey: ""
              }
            };
            if (response.data.connectionDetails !== null) {
              this.vmInfo.connectionDetails = {
                winAdminUser: response.data.connectionDetails.winAdminUser,
                winAdminPassword:
                  response.data.connectionDetails.winAdminPassword,
                vpnUser: response.data.connectionDetails.vpnUser,
                vpnPassword: response.data.connectionDetails.vpnPassword,
                vpnPresharedKey: response.data.connectionDetails.vpnPresharedKey
              };
            }

            this.sessionGuard();
          }
          if (!this.isInitialized) {
            this.isInitialized = true;
          }
          this.isLoading = false;
        })
        .catch(error => {
          this.showError(error);
          this.isLoading = false;
        });
    },
    keepAlive() {
      // keepVMAlive()
      //   .then(response => {
      //     console.log(response);
      //   })
      //   .catch(error => {
      //     this.showError(error);
      //   });
    },
    showError(error) {
      this.errorModalText =
        error.message ?? "Something went wrong, please try again";
      this.showErrorModal = true;
    },
    timerIncrement() {
      this.idleTime = this.idleTime + 1;
      console.log(this.idleTime);
    },
    async fetchSessions() {
      try {
        const response = await getSessions();
        const {
          totalCreditsForThisMonth = 0,
          usedCreditsThisMonth = 0
        } = response.data ? response.data : {};
        this.totalCreditsForThisMonth = totalCreditsForThisMonth;
        this.usedCreditsThisMonth = usedCreditsThisMonth;
        this.sessionGuard();
      } catch (error) {
        this.$notification.error({
          message: error.message || "Could not get user",
          description: "Unable to get VM sessions"
        });
      }
    },
    sessionGuard() {
      if (this.vmInfo && this.vmInfo.expectedShutdownTime) {
        const currentDateTime = new Date();
        const expectedShutdownTime = new Date(
          this.vmInfo.expectedShutdownTime || ""
        );

        console.log(
          "compare time",
          currentDateTime,
          expectedShutdownTime,
          isBefore(expectedShutdownTime, currentDateTime)
        );
        if (isBefore(expectedShutdownTime, currentDateTime)) {
          window.close();
        }
      }
    }
  },
  mounted() {
    this.getToken();
    setInterval(() => {
      this.getToken();
    }, 100000);

    this.fetchSessions();
    this.interval = setInterval(() => {
      this.sessionGuard();
    }, ONE_MINUTE);

    this.timerIncrementTimeout = setInterval(this.timerIncrement, ONE_MINUTE); // 1 minute
  },
  destroyed() {
    if (this.timerIncrementTimeout) {
      clearInterval(this.timerIncrementTimeout);
    }
  }
};
</script>

<style lang="scss">
@import "../styles/_variables.scss";

.iframe-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  padding-bottom: 60%;
}

.digital-twin-container {
  margin-top: -$navbarHeight;
}

.iframe-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.loading-container {
  margin-top: -$navbarHeight;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
